import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { DetailsSuccessModal } from '@shared/components/details-success-modal/details-success-modal.component';
import { NewSystemAccessComponent } from '@shared/components/new-system-access/new-system-access.component';
import { PersonDetailModalComponent } from '@shared/components/person-detail-modal/person-detail-modal.component';
import { PostalCodeInputComponent } from '@shared/components/postal-code-input/postal-code-input.component';
import { RequestApprovalModalComponent } from '@shared/components/request-approval-modal/request-approval-modal.component';
import { RevokeSystemAccessComponent } from '@shared/components/revoke-system-access/revoke-system-access.component';
import { SidebarNavigationComponent } from '@shared/components/sidebar-navigation/sidebar-navigation.component';
import { TopHeaderNavigationComponent } from '@shared/components/top-header-navigation/top-header-navigation.component';
import { UiComponentsModule } from '@shared/components/ui-components/ui-components.module';
import { UpdateDetailModalComponent } from '@shared/components/update-detail-modal/update-detail-modal.component';
import { ViewHistoryModalComponent } from '@shared/components/view-history-modal/view-history-modal.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { DirectivesModule } from './directives/directive.module';
@NgModule({
  declarations: [
    SidebarNavigationComponent,
    TopHeaderNavigationComponent,
    UpdateDetailModalComponent,
    NewSystemAccessComponent,
    ViewHistoryModalComponent,
    RevokeSystemAccessComponent,
    RequestApprovalModalComponent,
    DetailsSuccessModal,
    PersonDetailModalComponent,
    PostalCodeInputComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    MatSelectModule,
    MatCheckboxModule,
    UiComponentsModule,
    NgSelectModule,
    DirectivesModule,
    TabsModule.forRoot(),
  ],
  exports: [
    SidebarNavigationComponent,
    TopHeaderNavigationComponent,
    PostalCodeInputComponent
  ]
})
export class SharedModule { }
